(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-features-section"] && !window.DesignMode) return;
  try {
     
      jQuery(document).ready(function() {
        jQuery('#owl-cs-features-main').owlCarousel({
          loop:true,
          margin:10, 
  		  nav: true, 
          responsiveClass:true, 
          responsive:{
              0:{ 
                  items:1,
       			  margin:0,   
                  nav:true
              },
              320:{
                  items:2, 
                  nav:true 
              },
              767:{
                  items:3, 
                  nav:true, 
                  loop:false
              },
              1000:{
                  items:4, 
                  nav:true,
                  loop:false
              }
          }
      })
 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guarantee-logos"] && !window.DesignMode) return;
  try {
    
      jQuery(document).ready(function() {
        jQuery('#owl-logos').owlCarousel({
          loop:true,
          margin:10,
  		  nav: true,
          responsiveClass:true,
          responsive:{
              0:{
                  items:1,
                  nav:true
              },
               320:{
                  items:2,
                  nav:true 
              },
              
              768:{
                  items:2,
                  nav:false 
              }, 
              1000:{
                  items:2,
                  nav:true,
                  dots: false,
                  loop:true
              }
          }
      })

});

  } catch(e) { console.error(e); }
})();
      })();
